import { Theme } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles<Theme>(theme => ({
    alert: {
        color: '#666',
        backgroundColor: '#FFF',
        border: '1px solid #DDD',
        minHeight: 60,
        padding: 0,
        marginBottom: 30,

        '& .MuiAlert-message': {
            display: 'flex',
            flexDirection: 'row',
            fontSize: 16,
            margin: '-1px 0 -1px -1px',
            padding: 0,
        },
    },
    iconBox: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: 50,
        maxWidth: 50,
        borderTopLeftRadius: theme.variables.checkbox.borderRadius,
        borderBottomLeftRadius: theme.variables.checkbox.borderRadius,
        flex: '1 0 50px',
        backgroundColor: '#666',
    },
    iconImg: {
        height: 20,
        width: 20,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    textWrapper: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        fontSize: 16,
        color: '#666',
        padding: '20px',
        alignItems: 'flex-start',
        [theme.breakpoints.down('sm')]: {
            p: '15px 15px 15px 15px',
        },
    },
    button: {
        borderRadius: theme.variables.buttonOutlined.borderRadius,
        height: 32,
        borderColor: theme.color.border.main,
        borderWidth: 1,
        fontSize: 14,
        fontWeight: 600,
        textTransform: 'none',
        width: 'max-content',
        minWidth: 120,
        maxWidth: 250,
        color: '#000',
        '&:hover, &:active': {
            backgroundColor: theme.color.button.outlinedHover,
            borderColor: theme.color.border.active,
        },
    },
}))
